import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import './app.css';

import DashboardRoute from './routes/dashboard-route';
import UsersListRoute from './routes/users-list-route';
import UsersFormRoute from './routes/users-form-route';

import { FC } from 'react';
import AdminLayout from './components/layouts/admin-layout';
import AuthLayout from './components/layouts/auth-layout';
import LoginRoute from './routes/login-route';
import Authed from './components/authed';
import CategoriesListRoute from './routes/categories-list-route';
import CreditPacksListRoute from './routes/credit-packs-list-route';
import ImagesListRoute from './routes/images-list-route';
import OrdersListRoute from './routes/orders-list-route';
import ProductsFormRoute from './routes/products-form-route';
import ProductsListRoute from './routes/products-list-route';
import ImagesFormRoute from './routes/images-form-route';
import CreditPacksFormRoute from './routes/credit-packs-form-route';
import CategoriesFormRoute from './routes/categoris-form-route';
import InvoicesListRoute from './routes/invoices-list-route';
import { ConfigProvider } from 'antd';
import faIR from 'antd/es/locale/fa_IR';
import AdiveryLogsListRoute from './routes/adivery-logs-list-route';
import TransactionsListRoute from './routes/transactions-list-route';
import YassocialServicesListRoute from './routes/yassocial-services-route';
import TransactionsFormRoute from './routes/transactions-form-route';
import MessagesFormRoute from './routes/messages-form-route';
import MessagesListRoute from './routes/messages-list-route';
import DiscountsListRoute from './routes/discounts-list-route';
import DiscountsFormRoute from './routes/discounts-form-route';
import FollowermaServicesListRoute from './routes/followerma-services-route';
import CampaignsListRoute from './routes/campaigns-list-route';
const App: FC = () => {
  return (
    // <React.StrictMode>
    <ConfigProvider direction="rtl" locale={faIR}>
      <BrowserRouter >
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginRoute />} />
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/" element={<DashboardRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/users-list" element={<UsersListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/users-form" element={<UsersFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/invoices-list" element={<InvoicesListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/categories-list" element={<CategoriesListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/categories-form" element={<CategoriesFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/credit-packs-list" element={<CreditPacksListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/credit-packs-form" element={<CreditPacksFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/images-list" element={<ImagesListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/images-form" element={<ImagesFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/messages-list" element={<MessagesListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/messages-form" element={<MessagesFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/orders-list" element={<OrdersListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/adivery-logs-list" element={<AdiveryLogsListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/transactions-list" element={<TransactionsListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/products-list" element={<ProductsListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/products-form" element={<ProductsFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/users-list" element={<UsersListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/users-form" element={<UsersFormRoute />} />
            </Route>
          </Route>


          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/discounts-list" element={<DiscountsListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/campaigns-list" element={<CampaignsListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/discounts-form" element={<DiscountsFormRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/yassocial-services-list" element={<YassocialServicesListRoute />} />
            </Route>
          </Route>


          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/followerma-services-list" element={<FollowermaServicesListRoute />} />
            </Route>
          </Route>

          <Route element={<Authed />}>
            <Route element={<AdminLayout />}>
              <Route path="/transactions-form" element={<TransactionsFormRoute />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
    // </React.StrictMode>
  );
}

export default App;
